import { Fragment, useEffect } from "react";
import Footer from "./static/footer";
import Contact from "./static/contact";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

export const PrivacyPage = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const currentUser = useSelector((state) => state.currentUser);
  useEffect(() => {
    if (currentUser?.IsAuthenticated) {
      navigate("/");
    }
  }, [currentUser, navigate]);

  return (
    <Fragment>
      <div className="home-page" style={{ width: "100%", height: "100%" }}>
        <div id="blog" className="blog-area ptb-100 bg-f9f9f9">
          <div className="container">
            <div
              className="saas-section-title"
              data-aos="fade-up"
              data-aos-duration="800"
              data-aos-once="true"
              data-aos-delay="100"
            >
              <h4>{t("privacy.privacy")}</h4>
              <div className="bar"></div>
              <div className="terms-container">
                <p>
                  {t("privacy.privacy1")}
                  <a href="https://intelligence.cerebro360.ai/">
                    intelligence.cerebro360.ai
                  </a>{" "}
                  {t("privacy.privacy2")}
                </p>

                <h4>{t("privacy.info")}</h4>

                <h5>{t("privacy.personal")}</h5>
                <p>{t("privacy.personal1")}</p>

                <h5>{t("privacy.data")}</h5>
                <p>{t("privacy.data1")}</p>

                <h4>{t("privacy.use")}</h4>
                <p>{t("privacy.use1")}</p>
                <ul>
                  <li>{t("privacy.use2")}</li>
                  <li>{t("privacy.use3")}</li>
                  <li>{t("privacy.use4")}</li>
                  <li>{t("privacy.use5")}</li>
                  <li>{t("privacy.use6")}</li>
                </ul>

                <h4>{t("privacy.cookies")}</h4>
                <p>{t("privacy.cookies1")}</p>

                <h4>{t("privacy.google")}</h4>
                <h5>{t("privacy.googleuser")}</h5>
                <p>{t("privacy.googleusertxt")}</p>
                <h5>{t("privacy.dataretention")}</h5>
                <p>{t("privacy.dataretentiontxt")}</p>
                <h5>{t("privacy.datadeletion")}</h5>
                <p>{t("privacy.datadeletiontxt")}</p>
                <h5>{t("privacy.compliance")}</h5>
                <p>{t("privacy.compliancetxt")}</p>

                <h4>{t("privacy.services")}</h4>
                <p>{t("privacy.services1")}</p>

                <h4>{t("privacy.security")}</h4>
                <p>{t("privacy.security1")}</p>

                <h4>{t("privacy.rights")}</h4>
                <p>{t("privacy.right1")}</p>

                <h4>{t("privacy.changes")}</h4>
                <p>{t("privacy.changes1")}</p>

                <h4>{t("privacy.contact")}</h4>
                <p>
                  {t("privacy.contact1")}{" "}
                  <a href="mailto:bs@cerebro360.ai">bs@cerebro360.ai</a>.
                </p>
                <p>
                  {t("privacy.contact2")}{" "}
                  <a href="mailto:bs@cerebro360.ai">bs@cerebro360.ai</a>.
                </p>
              </div>
            </div>
          </div>
        </div>
        <Contact />
        <Footer />
      </div>

      <style>
        {`  
        .home-page h1, .home-page h4 {
            color: #333;
        }
        .home-page .terms-container {
            margin: 0 auto;
            background: #fff;
            padding: 20px;
            border-radius: 8px;
            text-align:left;
            box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        }
        .home-page .terms-container ul {
            padding-left: 20px;
        }
        .home-page  .terms-container .contact {
            margin-top: 20px;
            font-weight: bold;
        }
        .home-page .terms-container p{
        max-width:unset;
        }

         .home-page .terms-container h4{
          max-width:unset;
         }
        
        `}
      </style>
    </Fragment>
  );
};
